







































	import {Emit} from "vue-property-decorator";
	import {InOut} from 'vue-inout-prop-decorator';
	import {Component, Vue} from '@/shared/component';

	import {Locataire} from '@/models';

	import storeLocataire from "@/stores/modules/locataire";
	import CrudLocataireEditLocation from "@/components/Crud/Locataire/EditLocation.vue";

	@Component({
		components: {
			CrudLocataireEditLocation,
		}
	})
	export default class CrudLocataireEditLocationDialog extends Vue {
		@InOut({ type: Locataire  , isVModel: true }) private value!: Locataire;

		@Emit()
		private onSubmit(locataire: Locataire) {
			this.onClose();
		}

		@Emit()
		private async onClose(): Promise<void> {
			this.value = null;
		}

}
